import { resources } from "@constants/hardcoded-strings";
import { useMemo } from "react";
import styles from "./organization-users-name-email-label.less";
import { FormattedAxnAdminUserDetails } from "@idw-types/data/axn-admin-user";

type OrganizationUsersNameEmailLabelProps = {
    axnAdminUser: FormattedAxnAdminUserDetails;
    value: string;
};

export const OrganizationUsersNameEmailLabel = ({ axnAdminUser, value }: OrganizationUsersNameEmailLabelProps) => {

    const { firstName, lastName, email } = axnAdminUser;
    
    const labelElement = useMemo(() => {
        if (value !== resources.common.notFound) {
            return (<>
                <span>{`${firstName} ${lastName}`}</span>
                <span className={styles.emailLabel}>{email}</span>
            </>);

        } else {
            return <span>{value}</span>;
        }
    }, [value, firstName, lastName, email]);

    return (
        <span className={styles.organizationUsersNameEmailLabel}>
            {labelElement}
        </span>
    );
}